// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1gKzQ","visuallyhidden":"_20NH0","hide-text":"_2ntEM","center":"CDHvu","noprint":"_1CD3r","front":"_3aDeR"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/theme/app-front/default.scss
 ** module id = 975
 ** module chunks = 2
 **/